<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card
      [title]="'channel.title' | translate"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content>
        <form [formGroup]="channelForm">
          <div left-content class="content-container">
            <app-dropdown
              [label]="'channel.label'"
              [control]="channel"
              [options]="channelOptions"
              [optionsTranslationKey]="'channelOptions'"
            ></app-dropdown>
          </div>
        </form>
          <div actions class="navigationButtons">
            <button
              (click)="handleNextButtonClick()"
              mat-flat-button
              color="primary"
            >
              {{ "channel.nextButtonText" | translate }}
            </button>
            <button
              (click)="handleBackButtonClick()"
              mat-flat-button
              color="secondary"
            >
              {{ "channel.backButtonText" | translate }}
            </button>
          </div>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <form [formGroup]="channelForm">
        <div left-content class="content-container">
          <app-dropdown
            [label]="'channel.label'"
            [control]="channel"
            [options]="channelOptions"
            [optionsTranslationKey]="'channelOptions'"
          ></app-dropdown>
        </div>
      </form>
    </div>
  </ng-template>
</div>
